import React from "react";
import { Layout, GameReward } from "../components";

const GameRewardTokenPage = () => {
  return (
    <>
      <Layout>
        <GameReward />
      </Layout>
    </>
  );
};

export default GameRewardTokenPage;
